import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()

export class SpeadApiKeyInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (environment.speadApiUrl !== '' && request.url.includes(environment.speadApiUrl)) {
            const newRequest = request.clone(
                {headers: request.headers.set("X-Api-Key", environment.speadApiKey)});
            return next.handle(newRequest);
        }
        return next.handle(request);
    }
    
}